// Singleton that holds the browser tab a user opened by clicking the
// "View invoice" eye, while the app is still generating the PDF.
// This lets us keep the click handler synchronous (so the browser's
// popup blocker allows the new tab), then navigate that same tab to
// the final PDF Blob URL once generation finishes — instead of
// opening a *second* tab from the async pipeline.

let pendingTab: Window | null = null;

export const setPendingInvoiceTab = (win: Window | null) => {
  if (pendingTab && pendingTab !== win && !pendingTab.closed) {
    pendingTab.close();
  }
  pendingTab = win;
};

export const consumePendingInvoiceTab = (): Window | null => {
  const win = pendingTab;
  pendingTab = null;
  if (win && win.closed) return null;
  return win;
};
